const styles = ({ BREAKPOINTS }) => ({
  container: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& svg': {
      marginRight: '5px'
    }
  },
  title: {
    display: 'inline',
    marginRight: '18px'
  },
  count: {
    color: '#a3a3a3',
    display: 'block',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      display: 'inline'
    }
  }
})

export default styles
